export default __webpack_public_path__ + "static/media/play.608a4bfc.svg";